
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { CarRefItemStatus } from '../constants/car-basic-data';
import { AppUrl } from '../../common/constants/app-urls';
import { CarEngine } from '../models/car-engine.model';
import { CarFeature } from '../models/car-feature.model';
import { CarJobTask } from '../models/car-job-task.model';
import { CarJobTemplate } from '../models/car-job-template.model';
import { CarMake } from '../models/car-make.model';
import { CarManufacturer } from '../models/car-manufacturer.model';
import { CarModel } from '../models/car-model.model';
import { CarVersion } from '../models/car-version.model';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class CarRefService {

  constructor(private http: HttpClient) {}


  // Manufacturers
  addNewManufacturer(manufacturer: CarManufacturer): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.carref+"/manufacturers/new", 
        manufacturer, 
        httpOptions );
  }
  
  updateManufacturer(manufacturer: CarManufacturer): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/manufacturers/update", 
      manufacturer,
      httpOptions );  
  }

  updateManufacturerStatus(manufacturerId: number, status: CarRefItemStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/manufacturers/"+manufacturerId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  deleteManufacturer(manufacturerId: number): Observable<any>{ 
      
    return this.http.delete<any>(
      AppUrl.carref+"/manufacturers/"+manufacturerId, 
      httpOptions );  
  }

  fetchManufacturers(): Observable<any>{ 
      
    return this.http.get<any>(
      AppUrl.carref+"/manufacturers", 
      httpOptions );  
  }


  // Makes
  addNewMake(make: CarMake): Observable<any>{ 
      return this.http.post<any>(
          AppUrl.carref+"/makes/new", 
          make, 
          httpOptions );
    }
    
    updateMake(make: CarMake): Observable<any>{ 
        
      return this.http.post<any>(
        AppUrl.carref+"/makes/update", 
        make,
        httpOptions );  
    }
  
    updateMakeStatus(makeId: number, status: CarRefItemStatus): Observable<any>{ 
        
      return this.http.post<any>(
        AppUrl.carref+"/makes/"+makeId+"/update-status", 
        {data: status},
        httpOptions );  
    }
  
    deleteMake(makeId: number): Observable<any>{ 
        
      return this.http.delete<any>(
        AppUrl.carref+"/makes/"+makeId, 
        httpOptions );  
    }
  
    fetchMakes(manufacturerIds?: number[]): Observable<any>{ 

      let str = (manufacturerIds != undefined && manufacturerIds!.length > 0 ? "?manufacturerIds="+manufacturerIds : "");
        
      return this.http.get<any>(
        AppUrl.carref+"/makes"+str, 
        httpOptions );  
    }


  // Models
  addNewModel(model: CarModel): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.carref+"/models/new", 
        model, 
        httpOptions );
  }
  
  updateModel(model: CarModel): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/models/update", 
      model,
      httpOptions );  
  }

  updateModelStatus(modelId: number, status: CarRefItemStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/models/"+modelId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  deleteModel(modelId: number): Observable<any>{ 
      
    return this.http.delete<any>(
      AppUrl.carref+"/models/"+modelId, 
      httpOptions );  
  }

  fetchModels(makeIds?: number[]): Observable<any>{ 

    let str = (makeIds != undefined && makeIds!.length > 0 ? "?makeIds="+makeIds : "");
      
    return this.http.get<any>(
      AppUrl.carref+"/models"+str, 
      httpOptions );  
  }

  // Versions
  addNewVersion(version: CarVersion): Observable<any>{ 
      return this.http.post<any>(
          AppUrl.carref+"/versions/new", 
          version, 
          httpOptions );
    }
      
    updateVersion(version: CarVersion): Observable<any>{ 
        
      return this.http.post<any>(
        AppUrl.carref+"/versions/update", 
        version,
        httpOptions );  
    }
  
    updateVersionStatus(versionId: number, status: CarRefItemStatus): Observable<any>{ 
        
      return this.http.post<any>(
        AppUrl.carref+"/versions/"+versionId+"/update-status", 
        {data: status},
        httpOptions );  
    }
    
    deleteVersion(versionId: number): Observable<any>{ 
        
      return this.http.delete<any>(
        AppUrl.carref+"/versions/"+versionId, 
        httpOptions );  
    }
  
    fetchVersions(modelIds?: number[]): Observable<any>{ 

      let str = (modelIds != undefined && modelIds!.length > 0 ? "?modelIds="+modelIds : "");
        
      return this.http.get<any>(
        AppUrl.carref+"/versions"+str, 
        httpOptions );  
    }

  
    // Engines
  addNewEngine(engine: CarEngine): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.carref+"/engines/new", 
        engine, 
        httpOptions );
  }
  
  updateEngine(engine: CarEngine): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/engines/update", 
      engine,
      httpOptions );  
  }

  updateEngineStatus(engineId: number, status: CarRefItemStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/engines/"+engineId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  deleteEngine(engineId: number): Observable<any>{ 
      
    return this.http.delete<any>(
      AppUrl.carref+"/engines/"+engineId, 
      httpOptions );  
  }

  fetchEngines(manufacturerIds?: number[]): Observable<any>{ 

    let str = (manufacturerIds != undefined && manufacturerIds!.length > 0 ? "?manufacturerIds="+manufacturerIds : "");
      
    return this.http.get<any>(
      AppUrl.carref+"/engines"+str, 
      httpOptions );  
  }

  
  // Features
  addNewFeature(feature: CarFeature): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.carref+"/features/new", 
        feature, 
        httpOptions );
  }
  
  updateFeature(feature: CarFeature): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/features/update", 
      feature,
      httpOptions );  
  }

  updateFeatureStatus(featureId: number, status: CarRefItemStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/features/"+featureId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  deleteFeature(featureId: number): Observable<any>{ 
      
    return this.http.delete<any>(
      AppUrl.carref+"/features/"+featureId, 
      httpOptions );  
  }

  fetchFeatures(): Observable<any>{ 
  
    return this.http.get<any>(
      AppUrl.carref+"/features", 
      httpOptions );  
  }


    
  // JobTemplates
  addNewJobTemplate(jobTemplate: CarJobTemplate): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.carref+"/job-templates/new", 
        jobTemplate, 
        httpOptions );
  }
  
  updateJobTemplate(jobTemplate: CarJobTemplate): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/job-templates/update", 
      jobTemplate,
      httpOptions );  
  }

  updateJobTemplateStatus(jobTemplateId: number, status: CarRefItemStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carref+"/job-templates/"+jobTemplateId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  deleteJobTemplate(jobTemplateId: number): Observable<any>{ 
      
    return this.http.delete<any>(
      AppUrl.carref+"/job-templates/"+jobTemplateId, 
      httpOptions );  
  }

  fetchJobTemplates(): Observable<any>{ 
  
    return this.http.get<any>(
      AppUrl.carref+"/job-templates", 
      httpOptions );  
  }


    // JobTasks
    addNewJobTask(jobTask: CarJobTask): Observable<any>{ 
      return this.http.post<any>(
          AppUrl.carref+"/job-tasks/new", 
          jobTask, 
          httpOptions );
    }
    
    updateJobTask(jobTask: CarJobTask): Observable<any>{ 
        
      return this.http.post<any>(
        AppUrl.carref+"/job-tasks/update", 
        jobTask,
        httpOptions );  
    }
  
    updateJobTaskStatus(jobTaskId: number, status: CarRefItemStatus): Observable<any>{ 
        
      return this.http.post<any>(
        AppUrl.carref+"/job-tasks/"+jobTaskId+"/update-status", 
        {data: status},
        httpOptions );  
    }
  
    deleteJobTask(jobTaskId: number): Observable<any>{ 
        
      return this.http.delete<any>(
        AppUrl.carref+"/job-tasks/"+jobTaskId, 
        httpOptions );  
    }
  
    fetchJobTasks(): Observable<any>{ 
    
      return this.http.get<any>(
        AppUrl.carref+"/job-tasks", 
        httpOptions );  
    }
  
  
  private handleError<T> (task = 'task', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${task} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


}
